export const maybeApplyCallback = <T extends Function>(condition: boolean, fn: T) => {
  return condition ? fn : undefined;
};
